import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { Layout } from "@/components/Layout";
import { Spinner } from "@/components/common";

import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Library from "@/pages/Library";
import Studio from "@/pages/Studio";
import VoiceStudio from "@/pages/VoiceStudio";
import WalletPage from "@/pages/Wallet";
import Plans from "@/pages/Plans";
import PublicProfile from "@/pages/PublicProfile";
import SongPage from "@/pages/SongPage";
import Admin from "@/pages/Admin";
import Auth from "@/pages/Auth";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#09090b]"><Spinner className="text-purple-400 w-8 h-8" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/reset-password" element={<Auth mode="reset" />} />
            <Route path="/payment/success" element={<PaymentResult ok />} />
            <Route path="/payment/cancel" element={<PaymentResult />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/song/:id" element={<SongPage />} />
              <Route path="/u/:username" element={<PublicProfile />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/library" element={<Protected><Library /></Protected>} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/voice" element={<Protected><VoiceStudio /></Protected>} />
              <Route path="/wallet" element={<Protected><WalletPage /></Protected>} />
              <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
